export default {
  // app_id: 'spfxsxkcxqoxra', // 商品房销售许可查询
  app_id: 'clfwqhtcxtokfa', //存量房产交易网签查询/个人合同查询
  // app_id: 'fwbajgcxmklyj', // 房屋备案价格查询
  version: '1.0',
  charset: 'UTF-8',
  origin: '1',
  app_key: '7dd12acd7af24218bf1111b50db83714',
  app_secret: 'ec789fcae9fed18abbf7824e955f0f44'
}

/**
 * 打包须知：
 *
 * app_id要对应应用唯一标识
 * interface_id要对应接口的唯一标识
 *
 * 接口请求需要用到以上两个参数 如果以上两个参数和管理平台所给的唯一标识不一致 则接口请求失败
 *
 * pages.json要修改首页路由
 */